import { kindredColorTokens } from './tokens';

export const kindredThemes = {
  light: {
    background: kindredColorTokens.background,
    canvas: kindredColorTokens.canvas,
    canvasMuted: kindredColorTokens.canvasMuted,
    color: kindredColorTokens.foreground,
    colorMuted: kindredColorTokens.mutedForeground,
    heading: kindredColorTokens.heading,
    cardBackground: kindredColorTokens.card,
    cardForeground: kindredColorTokens.cardForeground,
    panelBackground: kindredColorTokens.panel,
    panelSoftBackground: kindredColorTokens.panelSoft,
    mutedBackground: kindredColorTokens.muted,
    tabBarBackground: kindredColorTokens.tabBar,
    inputBackground: kindredColorTokens.inputSoft,
    inputBorderColor: kindredColorTokens.input,
    borderColor: kindredColorTokens.border,
    borderStrong: kindredColorTokens.borderStrong,
    primary: kindredColorTokens.primary,
    primaryForeground: kindredColorTokens.primaryForeground,
    primarySoft: kindredColorTokens.primarySoft,
    secondary: kindredColorTokens.secondary,
    secondaryForeground: kindredColorTokens.secondaryForeground,
    secondarySoft: kindredColorTokens.secondarySoft,
    accent: kindredColorTokens.accent,
    accentForeground: kindredColorTokens.accentForeground,
    accentSoft: kindredColorTokens.accentSoft,
    success: kindredColorTokens.success,
    successForeground: kindredColorTokens.successForeground,
    destructive: kindredColorTokens.destructive,
    destructiveForeground: kindredColorTokens.destructiveForeground,
    shadowColor: kindredColorTokens.shadow,
    shadowStrongColor: kindredColorTokens.shadowStrong,
    overlayColor: kindredColorTokens.overlay,
  },
} as const;

export const kindredDefaultTheme = 'light' as const;
